import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import { Link as RouterLink } from "react-router-dom";
import grsLogo from "../assets/grs-logo.svg";

export const PageHeader = () => (
  <Paper elevation={0} square sx={{ py: 2 }}>
    <Container maxWidth="lg">
      <Link component={RouterLink} to="/" aria-label="Zur Startseite" sx={{ display: "inline-flex" }}>
        <Box component="img" src={grsLogo} alt="GRS Batterien" sx={{ height: { xs: 48, md: 64 } }} />
      </Link>
    </Container>
  </Paper>
);
